import styled, { AnyStyledComponent } from 'styled-components';
import { Switch } from 'antd';

export const GenericInputSwitchStyle = styled(
  Switch as unknown as AnyStyledComponent,
)``;
